import { useEffect } from "react";

export default function StringHelpers() {
  useEffect(() => {
    if (typeof String.prototype.toPascalCase !== "function") {
      Object.defineProperty(String.prototype, "toPascalCase", {
        value: function () {
          return this.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          });
        },
        configurable: true,
      });
    }

    if (typeof String.prototype.toCapitalized !== "function") {
      Object.defineProperty(String.prototype, "toCapitalized", {
        value: function () {
          if (this == null) return "";
          let s = String(this).trim();
          if (!s) return "";

          // Normalize separators: underscores and hyphens -> spaces
          s = s.replace(/[_-]+/g, " ");

          // Insert space between camelCase transitions: 'camelCase' -> 'camel Case'
          s = s.replace(/([a-z])([A-Z])/g, "$1 $2");

          // Collapse multiple spaces and capitalize each word
          return s
            .split(/\s+/)
            .map((part) => {
              if (!part) return "";
              return part.charAt(0).toUpperCase() + part.slice(1);
            })
            .join(" ");
        },
        configurable: true,
      });
    }

    // No cleanup necessary for prototypes; leave in place for app lifetime.
  }, []);

  return null;
}
